// src/components/registroEvento/RegistroForm/ContactoEmergenciaFieldArray.jsx
import React from 'react';
import { FieldArray } from 'formik';
import { Grid, TextField, IconButton, Typography, } from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';

const ContactoEmergenciaFieldArray = ({ values, handleChange }) => {
  return (
    <FieldArray
      name="contactoEmergencia"
      render={(arrayHelpers) => (
        <>
          {values.contactoEmergencia &&
            values.contactoEmergencia.map((contacto, index) => (
              <Grid container spacing={1} key={index} sx={{ mb: 1 }} alignItems="center">
                <Grid item xs={12} sm={5}>
                  <TextField
                    label="Nombre del contacto"
                    name={`contactoEmergencia[${index}].nombreEmergencia`}
                    value={contacto.nombreEmergencia || ''}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <TextField
                    label="Teléfono del contacto"
                    name={`contactoEmergencia[${index}].telefonoEmergencia`}
                    value={contacto.telefonoEmergencia || ''}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  {index > 0 && ( // El primer contacto no se puede eliminar
                    <IconButton color="error" onClick={() => arrayHelpers.remove(index)} size="small">
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            ))}
          {values.contactoEmergencia.length < 2 && (
            <IconButton
              color="primary"
              onClick={() => arrayHelpers.push({ nombreEmergencia: '', telefonoEmergencia: '' })}
              size="small"
            >
              <AddIcon fontSize="small" />
              <Typography>Agregar Contacto</Typography>
            </IconButton>
          )}
        </>
      )}
    />
  );
};

ContactoEmergenciaFieldArray.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ContactoEmergenciaFieldArray;
